import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { SegnalazioniService } from "./segnalazioni.service";

@Injectable({
    providedIn: 'root'
  })
export class AnomalieSegnalazioneDataSource implements DataSource<ModelEventiCalamitosi.AnomalieSegnalazioneDTO> {

    anomalieSegnalazioneSubject = new BehaviorSubject<ModelEventiCalamitosi.AnomalieSegnalazioneDTO[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    private errorSubject = new BehaviorSubject<boolean>(false);
    public errors$ = this.errorSubject.asObservable();
    isLoading: boolean = false;
    errorMessage: string = null;

    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();

    constructor(private segnalazioneService: SegnalazioniService) {
    }

    loadListAnomalieSegnalazione(codiceSegnalazione: number, lastMsgView:boolean) {

      this.loadingSubject.next(true);
      this.segnalazioneService.getListAnomalieSegnalazione(codiceSegnalazione,lastMsgView).pipe(
        catchError(err => {
          this.errorSubject.next(true);
          return throwError(err);
        }),
        catchError(err => {
          return of([]);
        }),
        finalize(() => this.loadingSubject.next(false))
      )
        .subscribe(result => {
          this.anomalieSegnalazioneSubject.next(result);
        }
        );
    }

    connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.AnomalieSegnalazioneDTO[]> {
      return this.anomalieSegnalazioneSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
      this.anomalieSegnalazioneSubject.complete();
      this.loadingSubject.complete();
    }
}
